export const Language = {
  EN: 'en',
  FR: 'fr',
  DE: 'de',
} as const;

export type Language = (typeof Language)[keyof typeof Language];
